/**
 * Copyright (c) 2025 Adaptive Chaos Labs, LLC
 * All rights reserved.
 */

/**
 * Returns true when both password fields have values and they do not match.
 */
export function hasPasswordConfirmationMismatch(password: string, confirmPassword: string): boolean {
  return Boolean(password) && Boolean(confirmPassword) && password !== confirmPassword;
}

/**
 * Returns true when password and confirmation are exactly equal.
 */
export function passwordsMatch(password: string, confirmPassword: string): boolean {
  return password === confirmPassword;
}
